import React from "react";
import { Box } from "@mui/material";
import Footer from "./Footer/Footer";
import styles from "./MainPageLayoutStyle";
import { Outlet, useLocation } from "react-router-dom";
import ResponsiveAppBar from "./Navbar/ResponsiveAppBar";
import useScrollToTop from "../hooks/useScrollToTop";

const ProtectedLayout = () => {
  const location = useLocation();
  // Use the scroll to top hook
  useScrollToTop();

  // Check if the current URL has a query parameter for step=9
  const searchParams = new URLSearchParams(location.search);
  const isCompletedStep =
    location.pathname === "/post-job" && searchParams.get("step") === "9";

  const navItems = {
    LANDLORD: [
      {
        id: 2,
        type: "link",
        label: "Manage Jobs",
        dropdown: true,
        dropdownItems: [
          {
            id: 1,
            label: "Pending Approvals",
            link: "/dashboard?view=pendingApprovals",
          },
          {
            id: 2,
            label: "Active Jobs",
            link: "/dashboard?view=activeJobs",
          },
          {
            id: 3,
            label: "Past Jobs",
            link: "/dashboard?view=pastJobs",
          },
          // {
          //   id: 4,
          //   label: "Saved Jobs",
          //   link: "/saved-jobs",
          // },
        ],
      },
      {
        id: 1,
        type: "link",
        label: "Properties",
        dropdown: true,
        dropdownItems: [
          {
            id: 1,
            label: "All Properties",
            link: "/dashboard?view=properties",
          },
          // {
          //   id: 2,
          //   label: "Edit Property",
          //   link: "/properties",
          // },
        ],
      },
      {
        id: 3,
        type: "link",
        label: "Invoices",
        dropdown: true,
        dropdownItems: [
          {
            id: 1,
            label: "Open Invoices",
            link: "/dashboard?view=openInvoices",
          },
          {
            id: 2,
            label: "Paid Invoices",
            link: "/dashboard?view=paidInvoices",
          },
        ],
      },
      {
        id: 3,
        type: "link",
        label: "Messages",
        link: "/dashboard?view=messages",
        dropdown: false,
      },
    ],
    PROPERTY_MANAGER: [
      {
        id: 2,
        type: "link",
        label: "Manage Jobs",
        dropdown: true,
        dropdownItems: [
          {
            id: 1,
            label: "Pending Approvals",
            link: "/dashboard?view=pendingApprovals",
          },
          {
            id: 2,
            label: "Active Jobs",
            link: "/dashboard?view=activeJobs",
          },
          {
            id: 3,
            label: "Past Jobs",
            link: "/dashboard?view=pastJobs",
          },
        ],
      },
      {
        id: 1,
        type: "link",
        label: "Properties",
        dropdown: true,
        dropdownItems: [
          {
            id: 1,
            label: "All Properties",
            link: "/dashboard?view=properties",
          },
        ],
      },
      {
        id: 3,
        type: "link",
        label: "Invoices",
        dropdown: true,
        dropdownItems: [
          {
            id: 1,
            label: "Open Invoices",
            link: "/dashboard?view=openInvoices",
          },
          {
            id: 2,
            label: "Paid Invoices",
            link: "/dashboard?view=paidInvoices",
          },
        ],
      },
      {
        id: 3,
        type: "link",
        label: "Messages",
        link: "/dashboard?view=messages",
        dropdown: false,
      },
    ],
    HOMEOWNER: [
      {
        id: 2,
        type: "link",
        label: "Manage Jobs",
        dropdown: true,
        dropdownItems: [
          {
            id: 2,
            label: "Active Jobs",
            link: "/dashboard?view=activeJobs",
          },
          {
            id: 3,
            label: "Past Jobs",
            link: "/dashboard?view=pastJobs",
          },
          // {
          //   id: 4,
          //   label: "Saved Jobs",
          //   link: "/saved-jobs",
          // },
        ],
      },
      {
        id: 1,
        type: "link",
        label: "Properties",
        dropdown: true,
        dropdownItems: [
          {
            id: 1,
            label: "All Properties",
            link: "/dashboard?view=properties",
          },
          // {
          //   id: 2,
          //   label: "Edit Property",
          //   link: "/properties",
          // },
        ],
      },
      {
        id: 3,
        type: "link",
        label: "Invoices",
        dropdown: true,
        dropdownItems: [
          {
            id: 1,
            label: "Open Invoices",
            link: "/dashboard?view=openInvoices",
          },
          {
            id: 2,
            label: "Paid Invoices",
            link: "/dashboard?view=paidInvoices",
          },
        ],
      },
      {
        id: 3,
        type: "link",
        label: "Messages",
        link: "/dashboard?view=messages",
        dropdown: false,
      },
    ],
    STR_HOST: [
      {
        id: 2,
        type: "link",
        label: "Manage Jobs",
        dropdown: true,
        dropdownItems: [
          {
            id: 2,
            label: "Active Jobs",
            link: "/dashboard?view=activeJobs",
          },
          {
            id: 3,
            label: "Past Jobs",
            link: "/dashboard?view=pastJobs",
          },
        ],
      },
      {
        id: 1,
        type: "link",
        label: "Properties",
        dropdown: true,
        dropdownItems: [
          {
            id: 1,
            label: "All Properties",
            link: "/dashboard?view=properties",
          },
        ],
      },
      {
        id: 3,
        type: "link",
        label: "Invoices",
        dropdown: true,
        dropdownItems: [
          {
            id: 1,
            label: "Open Invoices",
            link: "/dashboard?view=openInvoices",
          },
          {
            id: 2,
            label: "Paid Invoices",
            link: "/dashboard?view=paidInvoices",
          },
        ],
      },
      {
        id: 3,
        type: "link",
        label: "Messages",
        link: "/dashboard?view=messages",
        dropdown: false,
      },
    ],
    FAMILY_MEMBER: [
      {
        id: 2,
        type: "link",
        label: "Manage Jobs",
        dropdown: true,
        dropdownItems: [
          {
            id: 2,
            label: "Active Jobs",
            link: "/dashboard?view=activeJobs",
          },
          {
            id: 3,
            label: "Past Jobs",
            link: "/dashboard?view=pastJobs",
          },
        ],
      },
      {
        id: 1,
        type: "link",
        label: "Properties",
        dropdown: true,
        dropdownItems: [
          {
            id: 1,
            label: "All Properties",
            link: "/dashboard?view=properties",
          },
        ],
      },
      {
        id: 3,
        type: "link",
        label: "Invoices",
        dropdown: true,
        dropdownItems: [
          {
            id: 1,
            label: "Open Invoices",
            link: "/dashboard?view=openInvoices",
          },
          {
            id: 2,
            label: "Paid Invoices",
            link: "/dashboard?view=paidInvoices",
          },
        ],
      },
      {
        id: 3,
        type: "link",
        label: "Messages",
        link: "/dashboard?view=messages",
        dropdown: false,
      },
    ],
    TENANT: [
      {
        id: 1,
        type: "link",
        label: "Manage Jobs",
        dropdown: true,
        dropdownItems: [
          {
            id: 2,
            label: "Active Jobs",
            link: "/dashboard?view=activeJobs",
          },
          {
            id: 3,
            label: "Past Jobs",
            link: "/dashboard?view=pastJobs",
          },
          // {
          //   id: 4,
          //   label: "Saved Jobs",
          //   link: "/saved-jobs",
          // },
        ],
      },
      {
        id: 2,
        type: "link",
        label: "Messages",
        link: "/dashboard?view=messages",
        dropdown: false,
      },
    ],
    VENDOR: [
      {
        id: 1,
        type: "link",
        label: "Manage Jobs",
        dropdown: true,
        dropdownItems: [
          // {
          //   id: 1,
          //   label: "Pending Approvals",
          //   link: "/pending-approvals",
          // },
          {
            id: 1,
            label: "Available Jobs",
            link: "/dashboard?view=availableJobs",
          },
          {
            id: 2,
            label: "Active Jobs",
            link: "/dashboard?view=activeJobs",
          },
          {
            id: 3,
            label: "Past Jobs",
            link: "/dashboard?view=pastJobs",
          },
          // {
          //   id: 4,
          //   label: "Saved Jobs",
          //   link: "/saved-jobs",
          // },
        ],
      },

      {
        id: 2,
        type: "link",
        label: "Invoices",
        dropdown: true,
        dropdownItems: [
          {
            id: 1,
            label: "Open Invoices",
            link: "/dashboard?view=openInvoices",
          },
          {
            id: 2,
            label: "Paid Invoices",
            link: "/dashboard?view=paidInvoices",
          },
        ],
      },
      {
        id: 3,
        type: "link",
        label: "Messages",
        link: "/dashboard?view=messages",
        dropdown: false,
      },
    ],
  };

  return (
    <div style={styles.root}>
      <div style={styles.mainContainer}>
        {!isCompletedStep && <ResponsiveAppBar navItems={navItems} />}

        <Box>
          <Outlet />
        </Box>
        {location.pathname !== "/post-job" &&
          location.pathname !== "/vendor-onboarding" && <Footer />}
      </div>
    </div>
  );
};

export default ProtectedLayout;
